import { View, ViewRight } from 'common/types/view';
import { currentUserHasRight, currentUserIsLoggedIn } from 'common/current_user';
import DomainRights from 'common/types/domainRights';
import { hasRights } from 'common/views/has_rights';
import {
  isStory,
  isStoryDraft,
  isDerivedTabularView,
  isMeasure,
  isVisualizationCanvas,
  isDerivedReport,
} from 'common/views/view_types';

export const currentUserCanCopy = (view: View) => {
  // derived reports (saved states) can't be copied
  if (isDerivedReport(view)) {
    return false;
  }

  // shared checks across all asset types
  if (!hasRights(view, ViewRight.Read)) {
    return false;
  }

  if (isStoryDraft(view)) {
    return !!window.DRAFT_STORY_COPYABLE_BY_USER;
  }

  if (isStory(view)) {
    return !!window.PUBLISHED_STORY_COPYABLE_BY_USER;
  }

  if (isMeasure(view)) {
    return currentUserHasRight(DomainRights.create_measures);
  }

  if (isDerivedTabularView(view)) {
    return currentUserIsLoggedIn() && !!window.initialState?.canReadFromAllParents;
  }

  if (isVisualizationCanvas(view)) {
    return currentUserIsLoggedIn();
  }

  // The above are the only copyable asset types so far.
  return false;
};
